import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApiBasket, BasketUser } from 'src/api/basketService/types';
import { addUserToBasket } from 'src/api/basketService';
import { syncBasket } from 'src/utils/sync-basket';

import { queryRetry } from '../query-retry';

export const useAddUserToBasket = () =>
    useMutation<
        ApiBasket,
        AxiosError,
        { basketId: string; userData: BasketUser; updatedAt: string }
    >({
        mutationFn: ({ basketId, userData, updatedAt }) =>
            addUserToBasket(basketId, userData, updatedAt),
        retry: queryRetry,
        onSuccess: (basket) => {
            syncBasket(basket);
        },
    });
